import * as AddPhotos from '../insights/AddPhotos';
import * as LastMinuteAvailability from '../insights/LastMinuteAvailability';
import * as InviteClientsToBook from '../insights/InviteClientsToBook';
import * as AddStyleSeatToInstagram from '../insights/AddStyleSeatToInstagram';
import { getProviderInsights } from '../../../../modules/Api';
import storeReady from '../../../../store/ready';
import { getAppVersion } from '../../../../modules/AppInfo';

/**
 * useGetInsights - return getInsights function
 * getInsights - load insights, filter completed, return parsed results
 *
 * @returns array of Insights
 */
export const getInsights = async providerId => {
  const addPhotosInsights = await AddPhotos.getInsights(providerId);
  const lastMinuteAvailabilityInsight = await LastMinuteAvailability.getInsights();
  const inviteClientsToBookInsight = await InviteClientsToBook.getInsights();
  const addStyleSeatToInstagram = await AddStyleSeatToInstagram.getInsights();
  await storeReady; // Ensure our redux data has time to load
  const appVersion = getAppVersion();
  const insights = await getProviderInsights(providerId, appVersion);

  return [
    ...insights.results,
    addStyleSeatToInstagram,
    lastMinuteAvailabilityInsight,
    inviteClientsToBookInsight,
    ...addPhotosInsights,
  ].filter(Boolean);
};
